// extracted by mini-css-extract-plugin
export default {"underline":"Footer_underline__qxo1B"};